import { HttpService } from "@/core";
import { UserSimpleListReq, UserSimpleListResp } from "./work-plan-user.interface";


export class WorkPlanUserService {
  static useSimpleListApi() {
    const api = (projectId) =>
      HttpService.axios({
        method: "GET",
        url: `/work_set_up/project/user/list/${projectId}`,
      });
    return HttpService.useRequest<UserSimpleListResp>(api);
  }
}
